import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar, ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FestivalOverview() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section data-section-id="35677" id="sedation-overview" className="relative h-screen w-full overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay muted loop playsInline poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617360/img/tech_festival_hero_poster.png" className="h-full w-full object-cover opacity-40">
          {}
          <source src="/videos/tech_pulse_loop.mp4" type="video/mp4" />
        </video>
        
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-primary/20 via-background/40 to-background/95" />
        
        {}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.02)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_at_center,black_40%,transparent_80%)]" />
      </div>

      {}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8">
        <div ref={textRef} className={`flex flex-col items-center gap-6 transition-all duration-1000 ease-out ${textVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          {}
          <div className="inline-flex items-center gap-2 rounded-full border border-primary/20 bg-secondary px-4 py-1.5 text-sm font-semibold tracking-wide text-primary backdrop-blur-md">
            <SafeHydrate><Calendar className="h-4 w-4" /></SafeHydrate>
            <span>Gentle Sedation Dentistry</span>
          </div>

          {}
          <h1 className="max-w-5xl font-serif text-5xl font-bold tracking-tight text-foreground sm:text-7xl md:text-8xl lg:text-9xl">
            <span className="block text-transparent bg-clip-text bg-gradient-to-b from-foreground to-foreground/70">
              WAKE UP TO A
            </span>
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-primary via-primary/80 to-primary bg-[length:200%_auto] animate-[gradient_6s_linear_infinite]">
              NEW SMILE
            </span>
          </h1>

          {}
          <p className="max-w-2xl text-lg text-muted-foreground md:text-xl font-medium">
            Experience anxiety-free dental care with our specialized sedation options. 
            We prioritize your comfort for a stress-free transformation at Smart Choice.
          </p>
        </div>

        {}
        <div ref={ctaRef} className={`mt-12 transition-all duration-1000 delay-300 ease-out ${ctaVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <Button asChild size="lg" className="group relative h-14 overflow-hidden rounded-full border border-primary/20 bg-primary px-10 text-lg font-bold text-primary-foreground transition-all hover:shadow-xl hover:scale-105 active:scale-95">
            <Link to="/SedationPage">
              <span className="relative z-10 flex items-center gap-2">
                Explore Sedation Options
                <ArrowDown className="h-5 w-5 transition-transform duration-300 group-hover:translate-y-1" />
              </span>
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce text-primary/40">
        <ArrowDown className="h-6 w-6" />
      </div>
    </section>;
}